export default __webpack_public_path__ + "static/kubernetes-3a0aa89a79ded6ef9f7430f532746fa1.png";